import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plane } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

// Splash con animación del logo (primera carga)
export const SplashScreen = () => {
  const [show, setShow] = useState(() => !sessionStorage.getItem("ab_splash_seen"));
  const { t } = useLang();

  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem("ab_splash_seen", "1");
    const timer = setTimeout(() => setShow(false), 1900);
    return () => clearTimeout(timer);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-cream"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          data-testid="splash-screen"
        >
          <div className="flex flex-col items-center">
            <motion.div
              initial={{ scale: 0.6, opacity: 0, rotate: -25 }}
              animate={{ scale: 1, opacity: 1, rotate: 0 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="flex h-20 w-20 items-center justify-center rounded-full bg-coral shadow-[0_20px_40px_rgba(255,138,128,0.4)]"
            >
              <motion.div
                animate={{ x: [0, 6, 0], y: [0, -6, 0] }}
                transition={{ repeat: Infinity, duration: 1.4, ease: "easeInOut" }}
              >
                <Plane className="h-9 w-9 text-white" strokeWidth={2.5} />
              </motion.div>
            </motion.div>

            <motion.div
              initial={{ y: 18, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
              className="mt-6 text-center"
            >
              <p className="font-display text-3xl font-extrabold tracking-tight text-ink">
                Anto<span className="text-coral">&</span>Bella
              </p>
              <p className="mt-1 font-mono text-xs uppercase tracking-[0.3em] text-ink/40">
                {t("splash.tagline")}
              </p>
            </motion.div>

            <div className="mt-6 h-1 w-32 overflow-hidden rounded-full bg-ink/10">
              <motion.div
                className="h-full bg-mint"
                initial={{ x: "-100%" }}
                animate={{ x: "0%" }}
                transition={{ duration: 1.8, ease: "easeInOut" }}
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
